import { SvgInline } from "../SvgInline/SvgInline";
import styles from "./error-panel.module.scss";

export const ErrorPanel = ({ className = "", icon, children, ...props }) => (
  <div className={[styles.container, className].join(" ")} {...props}>
    <SvgInline name={icon} className={styles.icon} />
    <p className={styles.text}>{children}</p>
  </div>
);
